import React from "react";
import TableRow from "../../../../Components/Common/TableRow";
import TableData from "../../../../Components/Common/TableData";
import { convertToLocalDateTime } from "../../../../utils/convertToLocalDateTime";
import Button from "../../../../Components/Common/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faEye } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

const LiveClassRow = ({
  row,
  mutate,
  onClick,
  setIsModalOpen,
  setIsDetailsModalOpen,
}) => {
  return (
    <>
      <TableRow key={row._id}>
        <TableData>{row.title}</TableData>
        <TableData>
          {convertToLocalDateTime(row.date)?.split(",")?.[0]}
        </TableData>
        <TableData>{row.time}</TableData>
        <TableData>{row.duration}</TableData>
        <TableData>
          <span className="flex gap-2">
            {row?.meetingLink ? (
              <Link
                to={
                  row?.meetingLink.startsWith("http")
                    ? row.meetingLink
                    : `https://${row.meetingLink}`
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="py-1">
                  <Button
                    size="small"
                    className="flex gap-2 items-center text-xs"
                  >
                    Join
                    <FontAwesomeIcon icon={faArrowRight} />
                  </Button>
                </div>
              </Link>
            ) : null}
            {row?.recordingLink ? (
              <div className="py-1">
                <Button
                  size="small"
                  className="flex gap-2 items-center text-xs"
                  onClick={() => {
                    onClick(row);
                    setIsDetailsModalOpen(false);
                    setIsModalOpen(true);
                  }}
                >
                  Watch
                  <FontAwesomeIcon icon={faArrowRight} />
                </Button>
              </div>
            ) : null}
            <div className="py-1">
              <Button
                size="small"
                className="flex gap-2 items-center text-xs"
                onClick={() => {
                  onClick(row);
                  setIsDetailsModalOpen(true);
                }}
              >
                View
                <FontAwesomeIcon icon={faEye} />
              </Button>
            </div>
          </span>
        </TableData>
      </TableRow>
    </>
  );
};

export default LiveClassRow;
